import React from "react";
import { Input, Tooltip } from "antd";

// Ô lọc theo IP, dùng chung cho cả 3 tab log.
// Gõ đủ IPv4 → khớp chính xác; gõ dở ("14.161.") → khớp tiền tố cả dải.
// Chỉ nhận ký tự hợp lệ của IPv4/IPv6 để không bắn ký tự lạ xuống LIKE.
function LogIpFilter({ value, onChange, onSearch, width = 160 }) {
    return (
        <Tooltip title="Gõ đủ IP để khớp chính xác, hoặc gõ đầu dải (vd 14.161.) để lọc cả dải">
            <Input.Search
                style={{ width }}
                placeholder="IP"
                allowClear
                value={value}
                onChange={(e) => onChange(e.target.value.replace(/[^0-9a-fA-F.:]/g, ""))}
                onSearch={onSearch}
            />
        </Tooltip>
    );
}

export default LogIpFilter;
